<template>
  <div>
    <van-form>
      <van-field
        v-model="form.oldCard"
        name="用户名"
        label="旧卡号"
        placeholder="旧卡号"
        readonly
      />
      <van-field
        v-model="form.newCard"
        name="用户名"
        label="新卡号"
        placeholder="新卡号"
        readonly
      />
      <van-field
        v-model="form.state"
        name="用户名"
        label="换卡状态"
        placeholder="换卡状态"
        readonly
      />
      <van-field
        v-model="form.postNum"
        name="用户名"
        label="快递单号"
        placeholder="快递单号"
        readonly
      />
      <van-field
        v-model="form.boHuiRemark"
        name="用户名"
        label="备注"
        type="textarea"
        placeholder="备注"
        readonly
      />
    </van-form>
  </div>
</template>

<script>
  import { getByOldCard } from "../api/address";

  export default {
    data() {
      return {
        form: {},
      };
    },
    created() {},
    mounted() {
      this.getByOldCard();
    },
    methods: {
      getByOldCard() {
        getByOldCard().then((res) => {
          if (res.status) {
            if (res.data.state == -1) {
              res.data.state = "驳回";
            } else if (res.data.state == 0) {
              res.data.state = "审核中";
            } else if (res.data.state == 1) {
              res.data.state = "通过";
            }
            this.form = res.data;
          }
        });
      },
    },
  };
</script>

<style></style>
